<script>
import axios from 'axios'
import PayWidget from './components/PayWidget.vue'

const API_BASE = process.env.VUE_APP_API_BASE || ''

export default {
    name: 'App',
    components: { PayWidget },

    data() {
        return {
            state: 'loading',
            transaction: null,
            errorMessage: '',
            apiBase: API_BASE
        }
    },

    async mounted() {
        const transactionId = window.location.pathname.split('/').filter(Boolean)[0]
        if (!transactionId) {
            this.errorMessage = this.$t('invalidLink');
            this.state = 'error';
            return;
        }
        try {
            const res = await axios.get(`${API_BASE}/get-info/${transactionId}`)
            if (res.data.success) {
                this.transaction = res.data;
                this.state = 'ready';
            } else {
                this.errorMessage = this.$t('status_' + res.data.resultCode, this.$t('statusFallback'));
                this.state = 'error';
            }
        } catch (error) {
            const code = error.response?.data?.resultCode;
            this.errorMessage = this.$t('status_' + code, this.$t('statusFallback'));
            this.state = 'error';
        }
    }
}
</script>

<template>
  <div class="bg-[#044946] rounded-xl overflow-hidden shadow-md w-full max-w-sm mx-auto">

    <div v-if="state === 'loading'" class="flex justify-center py-8">
      <svg class="animate-spin h-8 w-8 text-blue-500" viewBox="0 0 24 24" fill="none">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
      </svg>
    </div>

    <div v-else-if="state === 'error'" class="text-center py-6 space-y-3">
      <p class="font-medium text-xl text-white">{{ $t('loadingTitle') }}</p>
      <p class="text-sm text-gray-300">{{ errorMessage }}</p>
    </div>

    <PayWidget
      v-else
      :transaction="transaction"
      :api-base="apiBase"
    />

  </div>
</template>